import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { Skeleton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import LottieDefault from 'react-lottie';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { ProductGrid } from '../../SearchResults/SearchResultsStyles.js';
import branclubloading from './brandclub_logo_load.js';

var Lottie = LottieDefault;
var defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: branclubloading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
var ProductGridLoading = function () {
    return (React.createElement(ProductGrid, { containerWidthOverride: false }, Array.from(Array(10).keys()).map(function (i, idx) {
        return (React.createElement(Skeleton, { key: idx, variant: "rectangular", width: '100%', height: 434, style: { borderRadius: 12 }, sx: { bgcolor: '#f6f8fa' } }));
    })));
};
var BrandclubLoading = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'star' : _b, lottieProps = _a.lottieProps, width = _a.width;
    if (type === 'productGrid') {
        return React.createElement(ProductGridLoading, null);
    }
    return (React.createElement("div", { style: {
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        } }, type === 'star' ? (React.createElement(Lottie, __assign({ options: defaultOptions, width: width || 200 }, lottieProps))) : (React.createElement(CircularProgress, { size: width || 100, sx: { color: brandclub_colors.mainSeriesColor } }))));
};

export { BrandclubLoading as default };
//# sourceMappingURL=index.js.map
